/*
 * "Mark as reviewed" is offered only while a document is still waiting for a clinician
 * (KIN-2114). A reviewed document is done, and a system-generated one is a letter or cert
 * the practice wrote itself, so there is nothing in it to review.
 */
const REVIEWABLE_STATUSES = ["NEW", "IN_REVIEW", "REFERRED"];

export const canMarkDocumentReviewed = (status) =>
  REVIEWABLE_STATUSES.includes(String(status ?? "").toUpperCase());
